<template>
  <div class="vld-parent py-2 gift-voucher-sub-component" :class="deploymentBgClass" id="voucherSale">
    <div class="container px-4 bgDarker">

      <div class="row mb-2">
        <div class="col text-center">
          <h2 class="my-4 font-weight-bold" :class="$deploymentCurrent == 'cryptology' ? 'font-mon' : ''">
            <template v-if="hasMultipleLocations">
              Gift Vouchers For {{ voucherUniversal ? brand : location.brand }}
            </template>
            <template v-else>
              Gift Vouchers For {{ brand }}
            </template>
          </h2>
        </div>
      </div>

<!--
      <div class="row mb-2">
        <div class="col-sm-12 col-md-2 col-lg-3"></div>
        <div class="col-sm-12 col-md-8 col-lg-6 text-center">
          <img
            :src="'/img/booking/' + $deploymentCurrent + '_vouchers.' + ($deploymentCurrent == 'makeyourescape' ? 'png' : 'jpg')"
            :alt="location.brand + ' Gift Vouchers'"
            class="img-fluid mb-2">
        </div>
        <div class="col-sm-12 col-md-2 col-lg-3"></div>
      </div>
-->

      <template v-if="expiry">
        <h4 class="mb-0 text-left">Gift Vouchers have an expiry of {{ expiryText }}<span v-if="voucherUniversal"> and can be used in all {{ brand }} branches</span>.</h4>
        <hr class="border-white">
      </template>

      <template v-if="playerVouchersAvailable.length">
        <h2 class="pt-4 pb-2 text-center text-uppercase font-weight-bold">Player Vouchers</h2>
        <p class="mb-0 text-left">&bull; Complete payment for <template v-if="$deploymentIs('rushden')">games at Rushden</template><template v-else-if="voucherUniversal">our</template><template v-else>{{ location.name }}’s</template> games</p>
        <p class="mb-0 text-left">&bull; Vouchers can be used for larger group sizes, the difference in cost will need to be paid on redemption.</p>
        <p v-if="$deploymentIs('escapable')" class="mb-0 text-left">&bull; The Great Loudini is a more expensive game, player vouchers redeemed for this game will have an additional fee to pay.</p>

        <div class="row" id="roomVoucher">
          <template v-for="voucher in playerVouchersAvailable">
            <div class="col-6 col-md-4" :class="playerVouchersAvailable.length == 5 ? 'col-lg-4' : 'col-lg-3'">
              <div class="generic-voucher mx-auto" :class="'generic-voucher-' + $deploymentCurrent" @click="voucherFor(voucher.amount, true)">
                <div class="price">Group of {{ voucher.amount }}</div>
                <div class="title my-1">
                  {{ voucher.standard_price | money }}
                </div>
                <small v-if="$deploymentIs('escapable') && voucher.amount > 6">Only For Outatime</small>
              </div>
            </div>
          </template>
        </div>
      </template>

      <template v-if="peakOffPeakVouchersAvailable.length"> <!-- PEAK & OFF-PEAK -->
        <div class="py-4" id="roomVoucher">
          <h2 class="py-4 text-center text-uppercase font-weight-bold">Peak Person Vouchers</h2>
          <div class="row">
            <div v-for="voucher in peakVouchersAvailable" :class="$deploymentIs('cryptology') ? 'col-6 col-md-4 col-lg-3' : 'col-sm-4'" @click="voucherFor(voucher.amount, true)">
              <div
                class="generic-voucher mx-auto"
                :class="'generic-voucher-' + $deploymentCurrent">
                <div class="price">Group of {{ voucher.amount }}</div>
                <div class="price" style="font-size: 20px;">Peak</div>
                <div class="title">{{ calculatePlayerVoucherCashEquivalent(voucher.amount, true) | money }}</div>
              </div>
            </div>
          </div>
          <h2 class="py-4 text-center text-uppercase font-weight-bold">Off-Peak Person Vouchers</h2>
          <div class="row">
            <div v-for="voucher in offPeakVouchersAvailable" :class="$deploymentIs('cryptology') ? 'col-6 col-md-4 col-lg-3' : 'col-sm-4'" @click="voucherFor(voucher.amount, false)">
              <div
                class="generic-voucher mx-auto"
                :class="'generic-voucher-' + $deploymentCurrent">
                <div class="price">Group of {{ voucher.amount }}</div>
                <div class="price" style="font-size: 20px;">Off-Peak</div>
                <div class="title">{{ calculatePlayerVoucherCashEquivalent(voucher.amount, false) | money }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template v-if="fixedMonetaryVouchersAvailable.length"> <!-- FIXED-MONEY PRICES -->
        <div id="moneyVoucher" class="py-4">
          <h2 class="py-4 text-center text-uppercase font-weight-bold">Monetary Vouchers</h2>
          <p class="mb-0 text-left" :class="$deploymentIs('m4escapes') ? 'text-center' : ''">&bull; Cash equivalent voucher for <template v-if="voucherUniversal">our</template><template v-else>{{ location.name }}’s</template> experiences</p>
          <p class="mb-0 text-left" :class="$deploymentIs('m4escapes') ? 'text-center' : ''">&bull; Vouchers can be used to (part-)pay for any booking.</p>

          <div class="row">
            <div v-for="voucher in fixedMonetaryVouchersAvailable" :class="$deploymentIn(['levelup', 'makeyourescape']) ? 'col-sm-4' : 'col-6 col-md-4 col-lg-3'" @click="resetCash(); addCash(voucher.amount); voucherCash()">
              <div class="generic-voucher mx-auto" :class="'generic-voucher-' + $deploymentCurrent">
                <div class="price">{{ voucher.amount | money }}</div>
                <div class="title">{{ voucher.amount | money }} Voucher</div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <div v-if="voucherCalculatorAmounts.length"> <!-- CREATE YOUR OWN MONEY VOUCHER -->
        <div class="pt-2 row" :id="$deploymentIs('cryptology') ? '' : 'moneyVoucher'">
          <div class="col-md-12">
            <h3 :class="$deploymentIs('cryptology') ? 'heading' : 'font-weight-bold'">Order Gift Vouchers To The Value Of&hellip;</h3>
            <p :class="$deploymentIs('cryptology') ? 'heading' : 'font-weight-bold'">Keep pressing until you get the amount you require</p>
          </div>
        </div>
        <div class="row px-3" :class="$deploymentIs('missionclassified') ? 'bg-gray-800' : ''">
          <div v-for="voucherCalculatorAmount in sortedVoucherCalculatorAmounts" class="col text-center py-3" :class="'border border-' + $deploymentCurrent + ' voucher-bg-' + $deploymentCurrent">
            <button
              type="button"
              class="btn-dark-green"
              :class="'button-' + $deploymentCurrent"
              @click="addCash(voucherCalculatorAmount)">
              &plus;{{ voucherCalculatorAmount | money }}
            </button>
          </div>
          <div class="col text-center py-3" :class="'border border-' + $deploymentCurrent + ' voucher-bg-' + $deploymentCurrent">
            <button
              type="button"
              :class="$deploymentIs('cryptology') ? 'btn btn-lg btn-orange' : 'btn-red button-' + $deploymentCurrent"
              @click="resetCash()">
              Clear
            </button>
          </div>
        </div>
        <div class="row px-3">
          <div class="col pt-3 pb-2" :class="'border border-' + $deploymentCurrent">
            <div class="row">
              <div class="col">
                <h3 class="text-right font-weight-bold">Voucher Total:</h3>
              </div>
              <div class="col">
                <h3 class="text-left font-weight-bold">{{ voucherCashTotal | money }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div class="row px-3 mb-3" :class="$deploymentIs('missionclassified') ? 'bg-gray-800' : ''">
          <div class="col text-center py-4" :class="'border border-' + $deploymentCurrent + ' voucher-bg-' + $deploymentCurrent">
            <button
              type="button"
              :class="purchaseVoucherClass"
              id="vouch_buy"
              :disabled="! voucherCashTotal"
              @click="voucherCash()">
              Confirm Voucher Amount
            </button>
          </div>
        </div>
      </div>

      <div class="">
        <div class="row my-2">
          <div class="col">
            <p v-if="$deploymentIs('housetrap')">If you have a voucher you wish to redeem against a booking, please redeem through the checkout.</p>
            <p v-else :class="$deploymentIs('cryptology') ? 'font-mon' : 'font-weight-bold'">If you have a voucher you wish to redeem against a booking, please redeem through the checkout, call us, or email us to arrange.</p>
            <p v-if="$deploymentIs('breakescape')" class="font-weight-bold">To upgrade to a physical voucher please use the button below to contact us or email us at <a href="mailto:play@breakescape.co.uk ">play@breakescape.co.uk</a></p>
            <p v-if="$deploymentIs('breakescape')" class="font-weight-bold">Please include the voucher value you’d like and the postal address where you want the voucher to be sent.</p>
            <p v-if="$deploymentIs('breakescape')">* Physical vouchers are charged at standard rate plus £3.00 for postage & processing.</p>
            <p v-if="$deploymentIs('breakescape')">* All vouchers are sent out First Class with Royal Mail within 2 days of purchase.</p>
          </div>
        </div>
      </div>

      <template v-if="showVoucherOptions">
        <hr class="border-black" id="voucherConfirmationBeforeCarting"/>
        <h2 class="heading voucher-confirm-title"><span class="material-icons text-orange" style="font-size: 150%; text-shadow:0 0 0.3em rgb(0, 0, 0);">help</span> Please Confirm Your Voucher Selection&hellip;</h2>

        <div class="row">
          <div class="col-sm-8">
            <h3 class="heading">Gift {{ voucherDescription }}</h3>

            <div class="form-group row">
              <label :for="$id('total')" class="col-sm-2 col-form-label">Amount</label>
              <div class="col-sm-10">
                <p class="mb-0">{{ voucherPreDiscountedTotal | money }}</p>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="form-group row">
                  <label class="col-sm-4 col-form-label" for="sendToPurchasingCustomer">
                    {{ sendType }} To Me
                  </label>
                  <div class="col-sm-8">
                    <div class="checkboxdiv">
                      <label class="checkboxdiv-label-lg">
                        <input
                          type="checkbox"
                          id="sendToPurchasingCustomer"
                          v-model="sendToPurchasingCustomer">
                        <span class="cr"><span class="cr-icon">&#10004;</span></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div> <!-- / .col -->
              <div class="col">
                <div class="form-group row">
                  <span class="col-sm-4 col-form-label">Delivery</span>
                  <div class="col-sm-8">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        v-model="sendBy"
                        name="sendBy"
                        :id="$id('methodE')"
                        :checked="isDecember && isAfterPostCutoff"
                        value="E"
                        checked>
                        <label class="form-check-label" :for="$id('methodE')">Email</label>
                      <br>
                      <template v-if="sellPostalVoucher">
                        <input
                          class="form-check-input"
                          type="radio"
                          v-model="sendBy"
                          name="sendBy"
                          :id="$id('methodP')"
                          :disabled="isDecember && isAfterPostCutoff"
                          value="P">
                          <label class="form-check-label" :for="$id('methodP')">Post</label>
                      </template>
                      <template v-if="collectVoucher">
                        <br>
                        <input
                          class="form-check-input"
                          type="radio"
                          v-model="sendBy"
                          name="sendBy"
                          :id="$id('methodI')"
                          value="I">
                          <label class="form-check-label" :for="$id('methodI')">Collect</label>
                      </template>
                    </div>
                  </div>
                </div>
              </div> <!-- / .col -->
            </div>

            <template v-if="sendToPurchasingCustomer">
              <div v-if="sendBy == 'P'" class="row">
                <p>Please enter your address below&hellip;</p>
                <textarea
                  v-model="postAddress"
                  class="form-control"
                  :class="{'is-invalid': postAddressError}"
                  rows="4"
                  placeholder="Address here..."></textarea>
                <div v-if="postAddressError" class="invalid-feedback d-block" role="alert">{{ postAddressError }}</div>
              </div>
            </template>
            <template v-else>
              <!-- NOT GOING TO THE PURCHASER -->
              <div class="alert alert-yellow">
                You have selected {{ sendBy == 'P' ? 'a postal' : 'an email' }} gift voucher for somebody else. Please enter their details below&hellip;
              </div>

              <div class="form-group row">
                <label :for="$id('recipientName')" class="col-sm-3 col-form-label">Recipient Name</label>
                <div class="col-sm-9">
                  <input
                    type="text"
                    :id="$id('recipientName')"
                    class="form-control"
                    :class="{'is-invalid': recipientNameError}"
                    v-model="recipientName"
                    placeholder="Recipient's Name">
                  <div v-if="recipientNameError" class="invalid-feedback d-block" role="alert">{{ recipientNameError }}</div>
                </div>
              </div>

              <template v-if="sendBy == 'P'">
                <div class="form-group row">
                  <label :for="$id('postAddress')" class="col-sm-3 col-form-label">Recipient Address</label>
                  <div class="col-sm-9">
                    <textarea
                      :id="$id('postAddress')"
                      rows="4"
                      class="form-control"
                      :class="{'is-invalid': postAddressError}"
                      v-model="postAddress"
                      placeholder="Full UK Address..."></textarea>
                      <div v-if="postAddressError" class="invalid-feedback d-block" role="alert">{{ postAddressError }}</div>
                  </div>
                </div>
              </template>
              <temmplate v-else-if="sendBy == 'E'">
                <div class="form-group row">
                  <label :for="$id('recipientEmail')" class="col-sm-3 col-form-label">Recipient Email</label>
                  <div class="col-sm-9">
                    <input
                      type="email"
                      :id="$id('recipientEmail')"
                      class="form-control"
                      :class="{'is-invalid': recipientEmailError}"
                      placeholder="Their email address"
                      v-model="recipientEmail">
                    <div v-if="recipientEmailError" class="invalid-feedback d-block" role="alert">{{ recipientEmailError }}</div>
                  </div>
                </div>
              </temmplate>

              <div class="form-group row">
                <label :for="$id('recipientMessage')" class="col-sm-3 col-form-label">Personalised Message</label>
                <div class="col-sm-9">
                  <textarea
                    :id="$id('recipientMessage')"
                    rows="3"
                    class="form-control"
                    v-model="recipientMessage"
                    placeholder="This is optional..."></textarea>
                </div>
              </div>
            </template>
          </div> <!-- / .col-sm-8 -->
          <div class="col-sm-4">
            <img :src="location.mpVoucherLandscapeSrc" class="img-fluid">
          </div>
        </div>

        <div v-if="isDecember && isAfterPostCutoff" class="alert alert-warning" role="alert">
          <div class="input-group input-group-lg row">
            <div class="col-sm-1">
              <i class="material-icons" aria-hidden="true">forward_to_inbox</i>
            </div>
            <div class="col-sm-11">
              <p class="mb-0">
                We are past Royal Mail postal cutoff for Christmas delivery.
                Only email vouchers can be purchased (unless you contact us)
              </p>
            </div>
          </div>
        </div>

        <div class="row pt-2 pb-4">
          <div class="col btn-group">
            <button type="button" class="btn btn-lg btn-danger" @click="clearVoucherChoice">Choose a different voucher</button>
            <button type="button"
              class="btn btn-lg btn-purple"
              @click="addVoucherToCart(false)"
              :disabled="addToCartButtonDisable">
              <span style="position: relative; top: -2px;">
                Add To Cart <span class="material-icons" style="position: relative; top: 5px;">add_shopping_cart</span>
              </span>
            </button>
            <button type="button"
              class="btn btn-lg btn-dark-green"
              @click="addVoucherToCart(true)"
              :disabled="addToCartButtonDisable"
              >Add &amp; Checkout <span class="material-icons">shopping_cart_checkout</span>
            </button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {Address} from 'address-rfc2821';

export default {
  props: {
    hasMultipleLocations: {
      type: Boolean,
    },
    location: {
      type: Object,
      required: true,
    },
    locationVoucherProducts: {
      type: Array,
      required: true,
    },
    saleFrom: {
      type: String,
      default: 'V',
    },
    locationDiscount: {
      type: Object,
    },
    postCutoff: {
      type: Object,
    },
    brand: {
      type: String,
      default: 'Cryptology',
    },
    sellPostalVoucher: {
      type: Boolean,
      default: false,
    },
    collectVoucher: {
      type: Boolean,
      default: false,
    },
    expiry: {
      type: Number,
    },
    voucherUniversal: {
      type: Boolean,
      default: false,
    },
    voucherCalculatorAmounts: {
      type: Array,
    },
    selectedCustomer: {
      type: Object,
    },
    deploymentBgClass: {
      type: String,
    },
    pricingStyle: {
      type: String,
      default: 'DEFAULT',
    },
  },

  data() {
    return {
      showVoucherOptions: false,

      sendBy: 'E',
      type: null,
      amount: null,

      postAddress: null,

      sendToPurchasingCustomer: true,

      recipientEmail: null,
      recipientName: null,
      recipientAddress: null,
      recipientMessage: null,

      numberOfPlayers: 0,
      voucherCashTotal: 0,

      isPeak: true,

      // validation errors
      postAddressError: false,
      recipientEmailError: false,
      recipientEmailSoftError: false,
      recipientNameError: false,
    };
  },

  computed: {
    listedVoucherProducts() {
      return this.locationVoucherProducts.filter(lvp => lvp.state == 'LISTED');
    },

    hasPeak() {
      return this.listedVoucherProducts.some(lvp => lvp.type == 'O');
    },

    playerVouchersAvailable() {
      if (this.hasPeak) {
        return [];
      }

      return this.listedVoucherProducts.filter(lvp => lvp.type == 'P');
    },

    peakOffPeakVouchersAvailable() {
      if (! this.hasPeak) {
        return [];
      }

      return this.listedVoucherProducts.filter(lvp => lvp.type != 'M');
    },

    peakVouchersAvailable() {
      if (! this.hasPeak) {
        return [];
      }

      return this.listedVoucherProducts.filter(lvp => lvp.type == 'P');
    },

    offPeakVouchersAvailable() {
      if (! this.hasPeak) {
        return [];
      }

      return this.listedVoucherProducts.filter(lvp => lvp.type == 'O');
    },

    fixedMonetaryVouchersAvailable() {
      return this.listedVoucherProducts.filter(lvp => lvp.type == 'M').sort((a, b) => a.amount - b.amount);
    },

    sortedVoucherCalculatorAmounts() {
      return this.voucherCalculatorAmounts.sort((a, b) => a - b);
    },

    addToCartButtonDisable() {
      if (this.type == null) {
        return true;
      }
      return false;
    },

    /**
     * Text for the voucher type
     * @return {string}
     */
    voucherDescription() {
      if (this.type == 'M') {
        this.amount = this.voucherCashTotal;
        return 'Voucher for ' + this.$money(this.voucherCashTotal);
      } else {
        this.amount = this.numberOfPlayers;
        if (this.hasPeak) {
          if (this.isPeak) {
            this.type = 'P';
            return 'Peak Voucher for ' + this.numberOfPlayers + ' players';
          } else {
            this.type = 'O';
            return 'Off-Peak Voucher for ' + this.numberOfPlayers + ' players';
          }
        }
        return 'Voucher for ' + this.numberOfPlayers + ' players';
      }
    },

    voucherPreDiscountedTotal() {
      if (this.type == 'M') { // is a money voucher (this.numberOfPlayers == 0)
        return this.voucherCashTotal;
      } else {
        return this.getPrice(this.numberOfPlayers,this.isPeak)
      }
    },

    purchaseVoucherClass() {
      switch (this.$deploymentCurrent) {
        case 'cryptology':
          return 'btn btn-lg btn-primary';
        case 'breakescape':
          return 'button-breakescape';
        default:
          return 'btn-primary button-' + this.$deploymentCurrent;
      }
    },

    isDecember() {
      // we only want this message displaying until Xmas Day, it is then irrelevant
      return (moment().format('M') == 12 && moment().format('D') < 25);
    },

    isAfterPostCutoff() {
      // this confirms if it is before the cutoff
      // var splitDate = this.postCutoff.split('.')[0].slice(1);
      var theDate = moment(this.postCutoff);
      return moment().isAfter(theDate);
    },

    postCutoffString() {
      return moment(this.postCutoff).format('dddd, Do MMMM YYYY, h:mm a');
    },

    todayDateString() {
      return moment().format('YYYY-MM-DD');
    },

    inPromo() {
      if (this.locationDiscount) {
        if (moment().isBetween(moment(this.locationDiscount.valid_from), moment(this.locationDiscount.expiry))) {
          return true;
        }
      }

      return false;
    },

    voucherPostDiscountedTotal() {
      if (this.inPromo) {
        return this.voucherPreDiscountedTotal * ((100 - parseInt(this.locationDiscount.percentage))/100);
      } else {
        return this.voucherPreDiscountedTotal;
      }
    },

    sendType() {
      if (this.sendBy == 'P') {
        return 'Post';
      }
      return 'Email';
    },

    contactNumberError() {
      if (this.contactNumber === null) {
        return null;
      } else {
        if (this.contactNumber == '***** ******') {
          return null;
        } else {
          if (this.contactNumber
            .match(/^(?:(?:\(?(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?(?:\(?0\)?[\s-]?)?)|(?:\(?0))(?:(?:\d{5}\)?[\s-]?\d{4,5})|(?:\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3}))|(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4})|(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}))(?:[\s-]?(?:x|ext\.?|\#)\d{3,4})?$/)
            ) {
            return null;
          } else {
            return 'Invalid phone number.';
          }
        }
      }
    },

    expiryText() {
      if (this.expiry) {
        if (this.expiry < 12) {
          return this.expiry + ' months';
        } else if (this.expiry == 12) {
          return '1 year';
        } else if (this.expiry == 18) {
          return '18 months';
        } else {
          return (this.expiry / 12).toString() + ' years';
        }
      }
      return null;
    }
  },

  methods: {
    range(start, end) { // this is for a v-for, it cannot not start at 0, vueIdiots
      return Array(end - start + 1).fill().map((_, idx) => start + idx);
    },

    calculatePlayerVoucherCashEquivalent(players, calculateForPeak = true) {
      return this.getPrice(players,calculateForPeak)
      return this.getPrice(players,calculateForPeak)
    },

    voucherFor(numPlayers, isPeak) {
      console.log('voucherFor', numPlayers, isPeak);

      this.voucherCashTotal = 0; // reset this
      this.numberOfPlayers = numPlayers;
      this.isPeak = isPeak;
      this.type = isPeak ? 'P' : 'O';

      // the next stage in the logic
      this.showVoucherOptions = true;

      this.$nextTick(() => {
        const yOffset = -100;
        const y = document.getElementById('voucherConfirmationBeforeCarting').getBoundingClientRect().top + window.scrollY + yOffset;
        this.$emit('scroll-dom-to-precise', y);
      });
    },

    voucherCash() {
      this.numberOfPlayers = 0; // reset
      this.isPeak = true; // reset
      this.type = 'M';

      if (this.voucherCashTotal == 0) {
        flash('No voucher amount chosen to purchase.','danger');
      } else {
        // the next stage in the logic
        this.showVoucherOptions = true;
        this.$nextTick(() => {
          const yOffset = -100;
          const y = document.getElementById('voucherConfirmationBeforeCarting').getBoundingClientRect().top + window.scrollY + yOffset;
          this.$emit('scroll-dom-to-precise', y);
        });
      }
    },

    addCash(amount) {
      this.voucherCashTotal += amount;
    },

    resetCash() {
      this.voucherCashTotal = 0;
    },

    clearVoucherChoice() {
      this.voucherInputsReset();
      document.getElementById('voucherSale').scrollIntoView({ behavior: 'smooth', block: 'start',});
    },

    voucherInputsReset() {
      console.log('voucherInputsReset');

      this.resetCash();
      this.showVoucherOptions = false;
      this.type = null;
      this.numberOfPlayers = 0;
      this.isPeak = true;

      this.emailError = false;
      this.emailSoftError = false;
    },

    getPrice(num_players, peak) { // this is pre-discount
      // find out whether it is a peak day or not
      let price = this.location.prices.find(price => price.price_for == num_players);

      if (this.pricingStyle == 'CHILD_TOTAL_PLAYERS') {
        if (peak) {
          return price.peak * num_players;
        } else {
          return price.offpeak * num_players;
        }
      } else {
        if (peak) {
          return price.peak;
        } else {
          return price.offpeak;
        }
      }
    },

    addVoucherToCart(checkoutAfterAdd) {
      console.log('addVoucherToCart');

      // Validation
      if (! this.sendToPurchasingCustomer) {
        // the extra steps to validate the extra details

        if (this.recipientName == null || this.recipientName == '') {
          this.recipientNameError = 'A recipient name is required.';
          flash('A recipient name is required.', 'danger');
        } else {
          this.recipientNameError = false;
        }

        if (this.sendBy == 'E') {
          if (this.recipientEmail == null || this.recipientEmail == '') {
            this.recipientEmailError = 'An email address is required.'; // Please enter a valid email address.
            flash('An email address is required.', 'danger');
          } else {
            this.recipientEmailError = false;
          }
        }
      }

      if (this.sendBy == 'P') {
        if (this.postAddress == null || this.postAddress == '') {
          this.postAddressError = 'You must fill in the address for us to post this gift voucher.'
          flash('You must fill in the address for us to post this gift voucher.', 'danger');
        } else {
          this.postAddressError = false;
        }
      }

      if (this.type == null) {
        flash('You must select a Voucher', 'danger');
      }

      if (this.recipientNameError
        || this.recipientEmailError
        || this.postAddressError
        || this.type == null) {
        flash('There are error(s) that need to be fixed.', 'danger');

        return;
      }

      // now let's find which Voucher option they have selected
      let voucherProductArrayIndex = this.locationVoucherProducts.findIndex(vp => vp.type == this.type && vp.amount == (this.type == 'M' ? this.voucherCashTotal : this.numberOfPlayers));

      if (this.type != 'M' && voucherProductArrayIndex == -1) {
        flash('There has been an unknown error, please contact Support.', 'danger');
      }
      var qty = 1;
      if (voucherProductArrayIndex == -1) {
        // this is a cash amount that is not in the db
        var intendedVoucherProduct = this.locationVoucherProducts.find(vp => vp.type == 'M' && vp.amount == 1);
        qty = this.voucherCashTotal;
      } else {
        var intendedVoucherProduct = this.locationVoucherProducts[voucherProductArrayIndex];
      }
      var voucherProductId = intendedVoucherProduct.id;

      var request = {
        location: this.location.slug,
        cartable: 'App\\Models\\VoucherProduct:' + voucherProductId,
        quantity: qty,
        options: {
          postAddress: this.postAddress,
          sendToPurchasingCustomer: this.sendToPurchasingCustomer,
          recipientEmail: this.recipientEmail,
          recipientName: this.recipientName,
          recipientAddress: this.recipientAddress,
          recipientMessage: this.recipientMessage,
          sendBy: this.sendBy,
          saleFrom: this.saleFrom,
        },
        soldFor: this.voucherPreDiscountedTotal,
        notes: null,
        roomResponses: [],
      };

      this.$emit('select-voucher-product', {request: request, checkoutAfterAdd: checkoutAfterAdd});

      if (this.selectedCustomer == null) {
        this.getCustomerDetails(checkoutAfterAdd)
        return false;
      }

      this.$nextTick(() => {
        this.$emit('add-voucher-to-cart');
      });

      this.voucherInputsReset();
    },

    getCustomerDetails(checkoutAfterAdd) {
      this.$emit('get-customer-details', checkoutAfterAdd);
      console.log('GiftVoucherSubComponent::emitted get-customer-details', checkoutAfterAdd);
    }, // getCustomerDetails()

  },

  mounted() {
    $(this.$refs.voucherModal).on('hidden.bs.modal', this.voucherModalHidden);
    $(this.$refs.confirmModal).on('hidden.bs.modal', this.confirmModalHidden);
  },
}
</script>
